import React from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import PersonalDashboard from "../pages/PersonalDashboard";
import { auth } from "../firebase";

export const AdminViewPersonal = () => {
  const { uid } = useParams();
  const location = useLocation();
  const state = location.state || {};
  const { adminView } = state;

  // Optional: very light check that current user is an admin
  // (real security is enforced by Firestore rules)
  const currentUser = auth.currentUser;
  // You could fetch users/{currentUser.uid} here and verify role === 'admin'
  // For now, we just require auth:
  if (!currentUser) {
    return <Navigate to="/admin-login" replace />;
  }

  return (
    <PersonalDashboard
      overrideUid={uid}
      adminView={!!adminView}
    />
  );
};
